export const GET_MATERIAS_REQUEST = 'GET_MATERIAS_REQUEST'
export const GET_MATERIA = 'GET_MATERIA'
export const GET_MATERIAS = 'GET_MATERIAS'
export const ADD_MATERIA = 'ADD_MATERIA'
export const DELETE_MATERIA = 'DELETE_MATERIA'
export const EDIT_MATERIA = 'EDIT_MATERIA'
export const MATERIA_FAIL = 'MATERIA_FAIL'
